import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
const CopyrightabilityEngine: React.FC = () => {
  return <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-tagblue via-tagblue-light to-tagblue text-white overflow-hidden">
        {/* Subtle 3D Background Elements */}
        <div className="absolute inset-0 z-0">
          <div className="absolute top-32 left-10 w-20 h-20 bg-white/10 rounded-2xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute top-20 right-20 w-16 h-16 bg-white/10 rounded-xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
          <div className="absolute bottom-32 left-20 w-12 h-12 bg-white/10 rounded-lg backdrop-blur-sm rotate-45 animate-float" style={{
          animationDelay: '4s'
        }} />
          <div className="absolute bottom-20 right-10 w-16 h-16 bg-white/10 rounded-xl backdrop-blur-sm -rotate-6 animate-float" style={{
          animationDelay: '1s'
        }} />
        </div>
        
        <div className="relative z-50">
          <Navbar />
        </div>
        <div className="container mx-auto px-6 py-20 text-center relative z-10">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-blue-100 drop-shadow-2xl">
                Copyrightability Engine
              </span>
            </h1>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 mb-8 border border-white/20 shadow-2xl animate-slide-up" style={{
            animationDelay: '0.2s'
          }}>
              <p className="text-white/95 text-xl md:text-2xl leading-relaxed">
                Our AI Flagship Framework that provides human versus AI effort percentage through our DAW plugin that captures stem-wise analysis during production. Enables intentional usage reporting by Creators & accurate overall percentage calculations during multi-track bounces.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-slide-up" style={{
            animationDelay: '0.4s'
          }}>
              <Link to="/join-waitlist">
                <Button className="bg-white text-tagblue hover:bg-blue-50 px-8 py-3 text-lg font-semibold rounded-full shadow-2xl hover:shadow-white/25 hover:scale-105 transform transition-all duration-300">
                  Join the Waitlist
                </Button>
              </Link>
              <Link to="/ai-music-framework">
                <Button variant="outline" className="bg-white/15 backdrop-blur-md border-white text-white hover:bg-white/25 px-8 py-3 text-lg font-semibold rounded-full border-white/30 shadow-xl transition-all duration-300">
                  AI Music Framework
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Copyrightability Engine Section */}
      <div className="py-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
        {/* 3D Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-32 h-32 bg-tagblue/10 rounded-3xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute bottom-20 right-20 w-24 h-24 bg-tagblue-light/10 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div>
              <h2 className="text-4xl font-bold mb-2">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900">
                  Copyrightability Engine
                </span>
              </h2>
              <p className="text-tagblue mb-6 text-lg">Our Flagship Product</p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our Copyrightability Engine provides a comprehensive solution for analyzing AI and human contributions in music production. Through our innovative DAW plugin, creators can track and report AI usage with precision and transparency.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Real-time stem-wise AI detection and analysis</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Precise percentage calculation of human vs AI effort</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Intentional AI usage reporting by creators</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Industry-standard compliance reporting</span>
                </div>
              </div>
              
              <Link to="/join-waitlist">
                <Button className="bg-tagblue text-white hover:bg-tagblue-dark px-8 py-3 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
                  Join the Waitlist
                </Button>
              </Link>
            </div>
            
            <div className="flex justify-center">
              <div className="bg-white rounded-3xl p-8 shadow-lg w-full max-w-md relative">
                {/* 3D floating elements around the interface */}
                <div className="absolute -top-4 -left-4 w-8 h-8 bg-white/30 rounded-xl rotate-45 animate-float" />
                <div className="absolute -bottom-4 -right-4 w-6 h-6 bg-tagblue/30 rounded-lg -rotate-12 animate-float" style={{
                animationDelay: '1s'
              }} />
                
                <div className="bg-gradient-to-br from-tagblue to-tagblue-dark p-6 rounded-xl mb-4 shadow-lg">
                  <img src="/lovable-uploads/29db7f3a-b096-46ac-abd7-19e81943ebff.png" alt="Copyrightability Engine Dashboard showing AI contributions analysis with charts and metrics" className="w-full h-auto rounded-lg" />
                </div>
                <div className="text-center">
                  <p className="text-sm text-tagblue mb-2">powered by</p>
                  <p className="text-lg font-semibold text-gray-800">TAG Plugin for DAW</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Latest Industry Developments - Hidden for now */}
      <div className="hidden">
        <div className="py-16 bg-white relative overflow-hidden">
...
        </div>
      </div>

      {/* Industry Standard CTA */}
      <div className="py-12 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* 3D Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-16 h-16 bg-tagblue/20 rounded-2xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute bottom-10 right-10 w-12 h-12 bg-tagblue-light/20 rounded-xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
        </div>
        
        <div className="container mx-auto px-6 text-center relative z-10">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-tagblue-light to-white">
                Be a step ahead and implement the industry Standard for AI Provenance?
              </span>
            </h3>
            <div className="bg-white/5 backdrop-blur-md rounded-2xl p-4 mb-6 border border-white/10 shadow-xl">
              <p className="text-gray-300 leading-relaxed">
                Join leading artists and producers who are already trying our copyrightability engine to maintain transparency and compliance.
              </p>
            </div>
            <Link to="/contact">
              <Button className="bg-tagblue text-white hover:bg-tagblue-dark px-8 py-3 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 transform">
                Contact us
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* For Every Industry Stakeholder */}
      <div className="py-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
        {/* 3D Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-28 h-28 bg-tagblue/10 rounded-3xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute bottom-20 right-20 w-20 h-20 bg-tagblue-light/10 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <h2 className="text-3xl font-bold text-center mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900">
              For Every Industry Stakeholder
            </span>
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-3xl mx-auto">
            Our tools suit all the players in the Industry with solutions for everyone
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -top-2 -right-2 w-6 h-6 bg-tagblue/20 rounded-lg rotate-45 animate-float opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue to-tagblue-dark rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">Label & Distribution Companies</h3>
              <p className="text-gray-600 mb-6">
                Get comprehensive reporting and analytics for all releases, ensuring compliance and transparency across your catalog.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• Automated compliance reporting</li>
                <li>• Bulk catalog analysis</li>
                <li>• Distribution platform integration</li>
                <li>• Artist royalty transparency</li>
              </ul>
            </Card>
            
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-tagblue-light/30 rounded-lg -rotate-12 animate-float opacity-0 group-hover:opacity-100 transition-opacity" style={{
              animationDelay: '1s'
            }} />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue-light to-tagblue rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">Streaming & Platform Solutions</h3>
              <p className="text-gray-600 mb-6">
                Integrate transparency tools directly into your platform to provide users with clear AI attribution information.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• Platform API integration</li>
                <li>• User transparency tools</li>
                <li>• Automated content flagging</li>
                <li>• Analytics dashboard</li>
              </ul>
            </Card>
            
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -top-2 -left-2 w-8 h-8 bg-white/30 rounded-xl rotate-45 animate-float opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue-dark to-tagblue rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">Regulatory Bodies</h3>
              <p className="text-gray-600 mb-6">
                Access standardized reporting tools and frameworks to monitor and regulate AI usage in the music industry.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• Industry compliance monitoring</li>
                <li>• Standardized reporting formats</li>
                <li>• Policy implementation tools</li>
                <li>• Data transparency frameworks</li>
              </ul>
            </Card>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-tagblue/20 rounded-lg rotate-45 animate-float opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue to-tagblue-light rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">Music & DAW</h3>
              <p className="text-gray-600 mb-6">
                Integrate our plugin directly into your DAW to provide real-time AI detection and attribution for your users.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• Real-time AI detection</li>
                <li>• Seamless DAW integration</li>
                <li>• Artist workflow tools</li>
                <li>• Export compliance reports</li>
              </ul>
            </Card>
            
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -top-2 -right-2 w-4 h-4 bg-tagblue-light/30 rounded-lg -rotate-12 animate-float opacity-0 group-hover:opacity-100 transition-opacity" style={{
              animationDelay: '1s'
            }} />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue-light to-tagblue-dark rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">AI Music Companies</h3>
              <p className="text-gray-600 mb-6">
                Partner with us to provide transparency tools for your AI-generated content, building trust with users and the industry.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• AI output attribution</li>
                <li>• Transparency reporting</li>
                <li>• Industry compliance</li>
                <li>• User trust building</li>
              </ul>
            </Card>
            
            <Card className="text-center p-8 hover:shadow-xl transition-all duration-300 group relative">
              <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-white/30 rounded-xl rotate-45 animate-float opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-16 h-16 bg-gradient-to-br from-tagblue-dark to-tagblue-light rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <div className="w-8 h-8 bg-white rounded"></div>
              </div>
              <h3 className="text-xl font-semibold mb-4">Copyright Offices</h3>
              <p className="text-gray-600 mb-6">
                Streamline copyright registration and management with automated AI detection and attribution reporting.
              </p>
              <ul className="text-left space-y-2 text-gray-600">
                <li>• Automated copyright filing</li>
                <li>• AI attribution tracking</li>
                <li>• Digital rights management</li>
                <li>• Legal compliance tools</li>
              </ul>
            </Card>
          </div>
        </div>
      </div>

      {/* TAG Plugin for DAW Section */}
      <section id="tag-plugin" className="py-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
        {/* 3D Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 right-10 w-32 h-32 bg-tagblue/10 rounded-3xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute bottom-20 left-20 w-24 h-24 bg-tagblue-light/10 rounded-2xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
            <div className="bg-white rounded-3xl p-8 shadow-lg relative">
              {/* 3D floating elements around the interface */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-white/30 rounded-xl rotate-45 animate-float" />
              <div className="absolute -bottom-4 -right-4 w-6 h-6 bg-tagblue/30 rounded-lg -rotate-12 animate-float" style={{
              animationDelay: '1s'
            }} />
              
              <div className="bg-gray-100 rounded-xl p-6 mb-6">
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Track 1 - Vocals</span>
                    <span className="text-sm text-tagblue font-semibold">Human: 90%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-gradient-to-r from-tagblue to-tagblue-light h-2 rounded-full" style={{
                    width: '90%'
                  }}></div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Track 2 - Guitar</span>
                    <span className="text-sm text-tagblue-dark font-semibold">AI: 60%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-gradient-to-r from-tagblue-dark to-tagblue h-2 rounded-full" style={{
                    width: '60%'
                  }}></div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Track 3 - Drums</span>
                    <span className="text-sm text-tagblue font-semibold">Human: 95%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-gradient-to-r from-tagblue to-tagblue-light h-2 rounded-full" style={{
                    width: '95%'
                  }}></div>
                  </div>
                  
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Track 4 - Bass</span>
                    <span className="text-sm text-tagblue-dark font-semibold">AI: 45%</span>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div className="bg-gradient-to-r from-tagblue-dark to-tagblue h-2 rounded-full" style={{
                    width: '45%'
                  }}></div>
                  </div>
                  
                  <div className="pt-4 border-t border-gray-300">
                    <div className="flex justify-between items-center font-semibold">
                      <span className="text-gray-800">Overall Composition</span>
                      <span className="text-tagblue">Human: 72%</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Copyrightability Engine</h3>
                <p className="text-sm text-tagblue mb-2">powered by</p>
                <p className="text-lg font-semibold text-tagblue">TAG Plugin for DAW</p>
              </div>
            </div>
            
            <div>
              <h2 className="text-4xl font-bold mb-2">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-gray-900 via-tagblue to-gray-900">
                  TAG Plugin for DAW
                </span>
              </h2>
              <p className="text-tagblue text-sm mb-6">Revolutionary Integration Technology</p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                Our revolutionary DAW plugin that seamlessly integrates into your workflow to provide real-time AI detection and attribution tracking. Monitor every stem and track to ensure complete transparency in your creative process.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Compatible with all major DAWs</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Real-time stem analysis and tracking</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Automated report generation</span>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-tagblue rounded-full mt-2 flex-shrink-0" />
                  <span className="text-gray-700 text-lg">Legal compliance documentation</span>
                </div>
              </div>
              
              <Link to="/join-waitlist">
                <Button className="bg-tagblue text-white hover:bg-tagblue-dark px-8 py-3 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
                  Join the Waitlist
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <div className="py-16 bg-gradient-to-br from-tagblue via-tagblue-light to-tagblue text-white relative overflow-hidden">
        {/* 3D Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-2xl backdrop-blur-sm rotate-12 animate-float" />
          <div className="absolute top-20 right-20 w-16 h-16 bg-white/10 rounded-xl backdrop-blur-sm -rotate-12 animate-float" style={{
          animationDelay: '2s'
        }} />
          <div className="absolute bottom-20 left-20 w-12 h-12 bg-white/10 rounded-lg backdrop-blur-sm rotate-45 animate-float" style={{
          animationDelay: '4s'
        }} />
          <div className="absolute bottom-10 right-10 w-18 h-18 bg-white/10 rounded-xl backdrop-blur-sm -rotate-6 animate-float" style={{
          animationDelay: '1s'
        }} />
        </div>
        
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl font-bold mb-6 animate-slide-up">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-white via-white to-blue-100 drop-shadow-2xl">
              Ready to Lead the Industry?
            </span>
          </h2>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 mb-8 border border-white/20 shadow-2xl animate-slide-up max-w-3xl mx-auto" style={{
          animationDelay: '0.2s'
        }}>
            <p className="text-white/95 text-xl leading-relaxed">
              Join the movement towards transparent AI usage in music production. Be part of the solution that's shaping the future of creative attribution.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>;
};
export default CopyrightabilityEngine;